var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _line, _line2, _circle4, _circle5, _circle6, _path5, _path6, _path7, _circle7, _circle8, _circle9, _path8, _path9, _path10, _path11, _line3, _path12, _path13, _path14, _path15, _path16, _path17, _line4, _line5, _line6, _line7, _line8, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#515570;}.cls-12,.cls-2{fill:#393c54;}.cls-15,.cls-2{opacity:0.5;}.cls-3{fill:#4bc190;}.cls-4{fill:#ff8475;}.cls-5{fill:#00adfe;}.cls-6,.cls-9{fill:#356cb6;}.cls-10,.cls-13,.cls-15,.cls-16,.cls-17,.cls-18,.cls-7,.cls-8{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-7{stroke:#4bc190;}.cls-7,.cls-8{stroke-width:20px;}.cls-8{stroke:#356cb6;}.cls-8,.cls-9{opacity:0.3;}.cls-10{stroke:#f85565;stroke-width:3px;}.cls-11{fill:#ffffff;}.cls-13,.cls-15,.cls-16,.cls-17,.cls-18{stroke:#515570;}.cls-13,.cls-15,.cls-16,.cls-18{stroke-width:2px;}.cls-13{opacity:0.4;}.cls-14{fill:#f85565;}.cls-16{opacity:0.1;}.cls-17{stroke-width:4px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 91.32,
    cy: 60.43,
    r: 7.93
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.94,36.78A5.12,5.12,0,0,0,87,36a6,6,0,0,0-5.08-5.92A6,6,0,0,0,76,25a5.12,5.12,0,0,0-.78.06,6,6,0,0,0-8.67-2A6,6,0,0,0,56,27c0,3.31,2.69,19,6,19,1.29,0,18.69,2,22,2a6,6,0,0,0,2.94-11.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,123.32a56.83,56.83,0,0,0,38-14.52l-2.27-5.31c-1.62-3.78-5.91-6.31-10.73-6.31H38c-4.82,0-9.11,2.53-10.73,6.31L25,108.8A56.83,56.83,0,0,0,63,123.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,124a59.77,59.77,0,0,0,39.83-15.14l-2.23-5.22c-1.71-4-6.22-6.64-11.29-6.64H38.64a1,1,0,0,0-1,.94L37,109.5s-4.78-6.82-6.52-9.24A1,1,0,0,0,29,100.1a10,10,0,0,0-2.61,3.54l-2.23,5.22A59.77,59.77,0,0,0,64,124Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.43,98.73a13.43,13.43,0,0,1-26.86,0c0-5,6-3.25,13.43-3.25S77.43,93.68,77.43,98.73Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 64,
    x2: 64,
    y1: 84.75,
    y2: 98.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 64,
    x2: 64,
    y1: 84.75,
    y2: 98.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 36.68,
    cy: 60.43,
    r: 7.93
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 91.32,
    cy: 60.43,
    r: 7.93
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 36.68,
    cy: 60.43,
    r: 7.93
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90,42a.22.22,0,0,0,0-.08c-.65,0-1.32.08-2,.08A26,26,0,0,1,62.49,21,3.91,3.91,0,0,0,62,21a6,6,0,0,0-6,6c0,3.31,2.69,19,6,19,1.29,0,18.69,2,22,2A6,6,0,0,0,90,42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86,44A26,26,0,0,1,60.24,21.5a2,2,0,0,0-2.4-1.71A28.32,28.32,0,0,0,35.68,47.43v18c0,15.43,12.1,28.47,27.52,28.89A28.32,28.32,0,0,0,92.32,66.05V47.43c0-.64,0-1.28-.07-1.91a2,2,0,0,0-2.32-1.82A25.42,25.42,0,0,1,86,44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M53.65,29.73a23.15,23.15,0,0,0-9,10.61"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 77.5,
    cy: 60,
    r: 5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 77.5,
    cy: 60,
    r: 1.75
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 50.5,
    cy: 60,
    r: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.33,60H44.67a5.83,5.83,0,0,1,11.66,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.33,60H44.67a5.83,5.83,0,0,1,11.66,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.33,60H71.67a5.83,5.83,0,0,1,11.66,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.33,60H71.67a5.83,5.83,0,0,1,11.66,0Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 60.17,
    x2: 63.83,
    y1: 86,
    y2: 86
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M70,83H58a4,4,0,0,1,0-8H70a4,4,0,0,1,0,8Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M57,75h3a0,0,0,0,1,0,0v1.5A1.5,1.5,0,0,1,58.5,78h0A1.5,1.5,0,0,1,57,76.5V75a0,0,0,0,1,0,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M56.36,82.64A3.9,3.9,0,0,0,58,83H70a3.9,3.9,0,0,0,1.64-.36C71.36,80.05,68.05,78,64,78S56.64,80.05,56.36,82.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M67.62,68.35,64.76,61.8a.61.61,0,0,0-1.12,0l-2.86,6.55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M85.75,70.5a7.5,7.5,0,0,0-7.5,7.5v5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M42.25,70.5a7.5,7.5,0,0,1,7.5,7.5v5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 69,
    x2: 82,
    y1: 50,
    y2: 50
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 46,
    x2: 59,
    y1: 50,
    y2: 50
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 44,
    x2: 49,
    y1: 36,
    y2: 39
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 48.44,
    x2: 52.56,
    y1: 30.44,
    y2: 34.56
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 68.5,
    x2: 68.5,
    y1: 81.5,
    y2: 85.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.16,99.52l-1,4.69a1,1,0,0,0,.57,1.12L37,109s-4.77-6.81-6.51-9.23A1,1,0,0,0,29.16,99.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar5);
export default __webpack_public_path__ + "static/media/avatar5.a7abf73c4ee35a70c0648a6515e54259.svg";
export { ForwardRef as ReactComponent };